import { useEffect, useRef, useState } from 'react'

// App de PONTO — standalone (token próprio do colaborador). Dead-simple: relógio ao
// vivo + 1 botão que detecta o próximo registro, com selfie + GPS.
const TK = 'ponto_token'
async function pontoApi(path: string, opts: any = {}) {
  const token = localStorage.getItem(TK)
  const r = await fetch(`/api/ponto${path}`, {
    ...opts,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(opts.headers || {}) },
  })
  if (r.status === 401) { localStorage.removeItem(TK); throw new Error('401') }
  if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.detail || 'Erro') }
  return r.json()
}

function Relogio() {
  const [now, setNow] = useState(new Date())
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t) }, [])
  const dias = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']
  return (
    <div className="text-center">
      <div className="text-6xl font-bold tracking-tight tabular-nums">{now.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}</div>
      <div className="text-white/70 text-sm mt-1">{dias[now.getDay()]}, {now.toLocaleDateString('pt-BR')}</div>
    </div>
  )
}

function Login({ onOk }: { onOk: (d: any) => void }) {
  const [cpf, setCpf] = useState(''); const [pin, setPin] = useState(''); const [erro, setErro] = useState(''); const [loading, setLoading] = useState(false)
  async function entrar() {
    setErro(''); setLoading(true)
    try {
      const d = await pontoApi('/login', { method: 'POST', body: JSON.stringify({ cpf, pin }) })
      localStorage.setItem(TK, d.access_token); onOk(d)
    } catch (e: any) { setErro(e.message === '401' ? 'CPF ou PIN inválido' : (e.message || 'Erro')) }
    finally { setLoading(false) }
  }
  return (
    <div className="min-h-screen bg-gradient-to-b from-sky-700 to-sky-900 flex flex-col items-center justify-center p-6 text-white">
      <div className="text-5xl mb-2">🕐</div>
      <h1 className="text-2xl font-bold mb-1">Ponto</h1>
      <p className="text-white/70 text-sm mb-8">Bata seu ponto pelo celular</p>
      <div className="w-full max-w-xs space-y-3">
        <input className="w-full rounded-2xl px-4 py-4 text-lg text-ink-900 text-center" inputMode="numeric"
          placeholder="CPF" value={cpf} onChange={e => setCpf(e.target.value)} />
        <input className="w-full rounded-2xl px-4 py-4 text-2xl text-ink-900 text-center tracking-widest" inputMode="numeric" type="password"
          placeholder="PIN" value={pin} onChange={e => setPin(e.target.value)} maxLength={6} />
        {erro && <div className="bg-rose-500/90 rounded-xl py-2 text-center text-sm">{erro}</div>}
        <button onClick={entrar} disabled={loading || !cpf || !pin}
          className="w-full rounded-2xl bg-white text-sky-800 font-bold py-4 text-lg disabled:opacity-50">
          {loading ? 'Entrando…' : 'Entrar'}</button>
      </div>
    </div>
  )
}

export default function PontoApp() {
  const [me, setMe] = useState<any>(null)
  const [hoje, setHoje] = useState<any>(null)
  const [batendo, setBatendo] = useState(false)
  const [msg, setMsg] = useState('')
  const [verEspelho, setVerEspelho] = useState(false)
  const [espelho, setEspelho] = useState<any>(null)
  const fileRef = useRef<HTMLInputElement>(null)
  const logado = !!localStorage.getItem(TK)

  async function carregar() {
    try { setMe(await pontoApi('/me')); setHoje(await pontoApi('/hoje')) }
    catch (e: any) { if (e.message === '401') { setMe(null) } }
  }
  useEffect(() => { if (logado) carregar() }, [])  // eslint-disable-line

  function pedirFoto() {
    setMsg('')
    fileRef.current?.click()  // abre câmera (capture=user)
  }

  async function aoTirarFoto(e: any) {
    const file = e.target.files?.[0]
    e.target.value = ''
    if (!file) return
    setBatendo(true); setMsg('Pegando localização…')
    const foto_base64: string = await new Promise(res => { const r = new FileReader(); r.onload = () => res(r.result as string); r.readAsDataURL(file) })
    const coords: any = await new Promise(res => {
      if (!navigator.geolocation) return res({})
      navigator.geolocation.getCurrentPosition(p => res({ lat: p.coords.latitude, lon: p.coords.longitude }), () => res({}), { timeout: 8000 })
    })
    try {
      setMsg('Registrando…')
      const d = await pontoApi('/bater', { method: 'POST', body: JSON.stringify({ ...coords, foto_base64 }) })
      setMsg(`✓ ${d.registro.label} às ${d.registro.hora}`)
      await carregar()
    } catch (err: any) { setMsg('⚠️ ' + (err.message || 'Erro ao bater')) }
    finally { setBatendo(false) }
  }

  async function abrirEspelho() { setVerEspelho(true); setEspelho(await pontoApi('/espelho')) }
  function sair() { localStorage.removeItem(TK); setMe(null) }

  if (!me) return <Login onOk={() => carregar()} />

  const prox = hoje?.proximo_label || 'Bater ponto'
  return (
    <div className="min-h-screen bg-gradient-to-b from-sky-700 to-sky-900 text-white flex flex-col">
      <input ref={fileRef} type="file" accept="image/*" capture="user" className="hidden" onChange={aoTirarFoto} />
      {/* Header */}
      <div className="flex items-center gap-3 p-4">
        {me.foto_url ? <img src={me.foto_url} className="w-11 h-11 rounded-full object-cover" />
          : <div className="w-11 h-11 rounded-full bg-white/20 flex items-center justify-center font-bold">{(me.nome || '?')[0]}</div>}
        <div className="flex-1 min-w-0"><div className="font-semibold truncate">{me.nome}</div>
          <div className="text-white/60 text-xs truncate">{me.cargo || 'Colaborador'}</div></div>
        <button onClick={sair} className="text-white/70 text-sm">Sair</button>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center px-6 gap-6">
        <Relogio />
        {msg && <div className="bg-white/15 rounded-xl px-4 py-2 text-center text-sm">{msg}</div>}
        <button onClick={pedirFoto} disabled={batendo}
          className="w-56 h-56 rounded-full bg-white text-sky-800 shadow-2xl flex flex-col items-center justify-center active:scale-95 transition disabled:opacity-60">
          <span className="text-5xl mb-2">📸</span>
          <span className="font-bold text-lg leading-tight px-4 text-center">{batendo ? 'Aguarde…' : prox}</span>
          <span className="text-xs text-sky-600 mt-1">toque e tire a selfie</span>
        </button>
      </div>

      {/* Hoje */}
      <div className="bg-white text-ink-900 rounded-t-3xl p-5 mt-4">
        <div className="flex items-center justify-between mb-2">
          <span className="font-semibold">Meu dia</span>
          <button onClick={abrirEspelho} className="text-sky-700 text-sm font-medium">Espelho do mês →</button>
        </div>
        {hoje?.registros?.length ? (
          <div className="space-y-1.5">
            {hoje.registros.map((r: any) => (
              <div key={r.id} className="flex items-center gap-2 text-sm">
                <span className="w-2 h-2 rounded-full bg-emerald-500" />
                <span className="flex-1">{r.label}</span>
                <span className="font-mono font-semibold">{r.hora}</span>
              </div>
            ))}
          </div>
        ) : <div className="text-ink-400 text-sm py-2">Nenhuma marcação hoje. Bata sua entrada 👆</div>}
      </div>

      {verEspelho && (
        <div className="fixed inset-0 bg-black/50 flex items-end z-50" onClick={() => setVerEspelho(false)}>
          <div className="bg-white text-ink-900 rounded-t-3xl w-full max-h-[80vh] overflow-auto p-5" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-3">
              <span className="font-semibold">Espelho — {espelho?.mes}</span>
              {espelho?.banco_horas && <span className="text-sm">Banco: <b className={espelho.banco_horas.startsWith('-') ? 'text-rose-600' : 'text-emerald-600'}>{espelho.banco_horas}</b></span>}
            </div>
            {(espelho?.dias || []).map((d: any) => (
              <div key={d.data} className="border-b py-2">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs text-ink-500">{d.data.split('-').reverse().join('/')}</span>
                  <span className="text-xs">{d.trabalhado}{d.saldo ? <span className={d.saldo.startsWith('-') ? 'text-rose-600' : 'text-emerald-600'}> ({d.saldo})</span> : ''}</span>
                </div>
                <div className="flex flex-wrap gap-2">
                  {d.marcacoes.map((m: any) => (
                    <span key={m.id} className="text-xs bg-ink-100 rounded px-2 py-1"><b>{m.hora}</b> {m.label}</span>
                  ))}
                </div>
              </div>
            ))}
            {!(espelho?.dias || []).length && <div className="text-ink-400 text-sm">Sem marcações no mês.</div>}
            <button onClick={() => setVerEspelho(false)} className="w-full mt-4 rounded-xl bg-sky-700 text-white py-3 font-semibold">Fechar</button>
          </div>
        </div>
      )}
    </div>
  )
}
